exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Picker {\r\n\tposition: fixed;\r\n\t/* background-color: #EAEAEA; */\r\n\tbackground-color: #F8F8F8;\r\n\toverflow: visible;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/Picker/Picker.css
// module id = 697
// module chunks = 0